import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

/**
 * Per-page TopBar content (title/subtitle/actions). Ported from
 * D:\campaigning-system\src\layout\PageChrome.tsx (types stripped).
 * Each route declares its chrome via usePageChrome(); the TopBar reads it.
 */
const PageChromeContext = createContext(null);

export function PageChromeProvider({ children }) {
  const [chrome, setChrome] = useState({ title: 'CampaignOS' });
  const value = useMemo(() => ({ chrome, setChrome }), [chrome]);
  return <PageChromeContext.Provider value={value}>{children}</PageChromeContext.Provider>;
}

export function usePageChromeState() {
  const ctx = useContext(PageChromeContext);
  if (!ctx) throw new Error('PageChrome context missing');
  return ctx.chrome;
}

/** Route hook: declare the TopBar content for this page. Re-runs when deps change. */
export function usePageChrome(factory, deps) {
  const ctx = useContext(PageChromeContext);
  if (!ctx) throw new Error('PageChrome context missing');
  const { setChrome } = ctx;
  useEffect(() => {
    setChrome(factory());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
